import React from 'react'
import { Avatar, Box, Typography } from '@mui/material'

const getInitialsFromName = (name = '') => {
  const words = name
    .trim()
    .split(/\s+/)
    .filter(Boolean)

  if (words.length === 0) return ''
  if (words.length === 1) return words[0][0].toUpperCase()

  const first = words[0][0]
  const last = words[words.length - 1][0]

  return `${first}${last}`.toUpperCase()
}

const UIAvatar = ({
  name,
  src,
  alt,
  size = 56,
  isOnline,
  showStatus = false,
  onlineText = 'LIVE',
  offlineText = 'OFFLINE',
}) => {
  const initials = getInitialsFromName(name)
  const ariaLabel = alt || name || 'Doctor avatar'
  const statusLabel = isOnline ? onlineText : offlineText
  const dotColor = isOnline ? '#22c55e' : '#6b7280'

  return (
    <Box
      sx={{ position: 'relative', display: 'inline-flex' }}
      className={isOnline ? 'avatar-pulse' : undefined}
    >
      {isOnline && (
        <>
          <Box className="avatar-pulse-ring" />
          <Box className="avatar-pulse-ring delay" />
        </>
      )}
      <Avatar
        src={src || undefined}
        alt={ariaLabel}
        sx={{
          width: size,
          height: size,
          position: 'relative',
          zIndex: 1,
          ...(src ? {} : { fontSize: '5rem' }),
        }}
      >
        {!src && initials}
      </Avatar>

      {showStatus && (
        <Box
          sx={{
            position: 'absolute',
            // bottom: 4,
            bottom: '-3%',
            left: '50%',
            transform: 'translateX(-50%)',
            bgcolor: '#111827',
            color: '#ffffff',
            borderRadius: '999px',
            px: 1.5,
            py: 0.25,
            display: 'flex',
            alignItems: 'center',
            gap: 0.75,
            boxShadow: '0 4px 10px rgba(0,0,0,0.25)',
            padding:"0.25rem 0.5rem",
            zIndex: 2,
          }}
        >
          <Box
            sx={{
              width: 8,
              height: 8,
              borderRadius: '50%',
              bgcolor: dotColor,
            }}
          />
          <Typography
            variant="caption"
            sx={{
              fontWeight: 600,
              textTransform: 'uppercase',
              fontSize: '0.5rem',
              lineHeight:0,
            }}
          >
            {statusLabel}
          </Typography>
        </Box>
      )}
    </Box>
  )
}

export default UIAvatar
